import axios from "axios";
import { joinUrl } from "./url";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Re-export the joiner so existing call sites can import either path.
export { joinUrl };

/**
 * Build a fully-qualified backend URL from a path. ALL frontend code that
 * needs to construct a backend URL (window.location redirects, file
 * downloads, anchor hrefs, etc.) should call this helper instead of string
 * interpolation against `process.env.REACT_APP_BACKEND_URL`.
 */
export const apiUrl = (path) => joinUrl(BACKEND_URL, `/api/${String(path || "").replace(/^\/+/, "")}`);

export const API = joinUrl(BACKEND_URL, "/api");

// withCredentials: true so the admin httpOnly cookie set by the backend is sent on every API call.
export const api = axios.create({ baseURL: API, withCredentials: true });

// A write refused during the team's portal preview (22.10.2026) says so in the
// preview banner, even where a page swallows its own errors.
export const PREVIEW_REFUSED_EVENT = "fped:portal-preview-refused";
api.interceptors.response.use(undefined, (err) => {
  const d = err?.response?.data?.detail;
  if (err?.response?.status === 403 && typeof d === "string" && d.startsWith("Ești în previzualizare")
      && typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(PREVIEW_REFUSED_EVENT, { detail: d }));
  }
  return Promise.reject(err);
});

/**
 * Turn an axios/FastAPI error into a human-readable string. FastAPI's `detail`
 * is a string for HTTPException but a LIST of {type, loc, msg, ...} objects for
 * 422 validation errors — passing that array to toast/JSX crashes React. This
 * always returns a string.
 */
/**
 * Pydantic v2 prefixes messages raised by a custom validator with the error
 * class — `"Value error, Logo-ul trebuie să înceapă cu https://"`. That prefix
 * is noise for the person reading the toast, and it is English in an otherwise
 * Romanian message. Strip it; keep everything after it untouched.
 */
function stripPydanticPrefix(msg) {
  return String(msg).replace(/^(Value error|Assertion failed|Type error),\s*/i, "");
}

export function apiErrorMessage(err, fallback = "A apărut o eroare. Încearcă din nou.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const msgs = d.map((e) => (typeof e === "string" ? e : e?.msg)).filter(Boolean).map(stripPydanticPrefix);
    if (msgs.length) return msgs.join("; ");
  }
  return fallback;
}

export default api;
